import React from 'react';
import { CellProps } from 'react-table';
import { faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import classNames from 'classnames';
import styles from '../assets/internal-actions.module.scss';
import { IInternal } from 'src/types/internal';
import DeleteInternalAction from './DeleteInternalAction';

const InternalActionsColumn: React.FunctionComponent<CellProps<IInternal>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IInternal>) => {
    return (
        <div className={classNames(styles.actions)}>
            {original.status !== 4 ? (
                <div className={'d-flex'}>
                    <Link
                        className="btn btn-info  mr-2"
                        to={Router.generate(routes.INTERNAL_EDIT, { id: original.id })}
                    >
                        <FontAwesomeIcon icon={faPencilAlt} />
                    </Link>
                    <DeleteInternalAction data={original} />
                </div>
            ) : null}
        </div>
    );
};

export default InternalActionsColumn;
